import script from "./CreateSimulationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSimulationPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateSimulationPage.vue?vue&type=style&index=0&id=e917620a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e917620a"]])

export default __exports__